import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import cn from 'classnames';
import Slider from '@wix/da-ds/pkg/Slider';
import { useEditorContext } from '../../Editor/Context';
import { useForceUpdate } from '../../../hooks/useForceUpdate';
import Bold from '../buttons/Bold';
import Italic from '../buttons/Italic';
import Strike from '../buttons/Strike';
import Underline from '../buttons/Underline';
import BlockFormatting from '../buttons/BlockFormatting';
import BulletList from '../buttons/BulletList';
import OrderedList from '../buttons/OrderedList';
import HRule from '../buttons/HRule';
import Blockquote from '../buttons/Blockquote';
import ClearFormatting from '../buttons/ClearFormatting';
import Undo from '../buttons/Undo';
import Redo from '../buttons/Redo';
import Alignment from '../buttons/Alignment';
import Separator from '../buttons/Separator';
import Link from '../buttons/Link';
import FontFamily from '../buttons/FontFamily';
import FontColor from '../buttons/FontColor';
import FontHighlight from '../buttons/FontHighlight';
import LinkAnchor from '../buttons/LinkAnchor';
import Reaction from '../buttons/Reaction';
import Deviation from '../buttons/Deviation';
import Gallery from '../buttons/Gallery';
import Gif from '../buttons/Gif';
import SliderNext from '../buttons/SliderNext';
import SliderPrev from '../buttons/SliderPrev';
import AddMedia from '../buttons/AddMedia';
import List from '../buttons/List';
import TextDecoration from '../buttons/TextDecoration';
import Indent from '../buttons/Indent';
import Outdent from '../buttons/Outdent';
import Video from '../buttons/Video';
import { ThemeSurface } from '@wix/da-react-context/pkg/constants';
import { ThemeOverride } from '@wix/da-react-context/pkg/ThemeContext';
import Muro from '../buttons/Muro';
import { isTouch as getIsTouch } from '../../utils/browser';
import s from './EverythingMenu.scss';
const EverythingMenu = ({ wrapping = true, noAtomics = false, omitHRule = false, className })=>{
    const editor = useEditorContext();
    const isTouch = getIsTouch();
    const forceUpdate = useForceUpdate();
    // Listen to editor as its not react so we need to react here
    editor === null || editor === void 0 ? void 0 : editor.on('transaction', ()=>{
        forceUpdate();
    });
    if (!editor) {
        return null;
    }
    let buttons = /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Undo, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Redo, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Separator, {
        editor: editor
    }), !noAtomics && /*#__PURE__*/ React.createElement(Reaction, {
        editor: editor
    }), !noAtomics && /*#__PURE__*/ React.createElement(Deviation, {
        editor: editor
    }), !noAtomics && /*#__PURE__*/ React.createElement(Gallery, {
        editor: editor
    }), !noAtomics && /*#__PURE__*/ React.createElement(Gif, {
        editor: editor
    }), !noAtomics && /*#__PURE__*/ React.createElement(Video, {
        editor: editor
    }), !noAtomics && /*#__PURE__*/ React.createElement(Muro, {
        standalone: true,
        editor: editor
    }), !noAtomics && /*#__PURE__*/ React.createElement(Separator, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(BlockFormatting, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Separator, {
        editor: editor,
        hideWhen: 'heading'
    }), /*#__PURE__*/ React.createElement(Bold, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Italic, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Underline, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Strike, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(FontFamily, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(FontColor, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(FontHighlight, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Separator, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Link, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(LinkAnchor, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Separator, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Alignment, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Outdent, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Indent, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Blockquote, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(OrderedList, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(BulletList, {
        editor: editor
    }), !omitHRule && /*#__PURE__*/ React.createElement(HRule, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Separator, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(ClearFormatting, {
        editor: editor
    }));
    if (isTouch) {
        buttons = /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Undo, {
            editor: editor
        }), /*#__PURE__*/ React.createElement(Redo, {
            editor: editor
        }), /*#__PURE__*/ React.createElement(Separator, {
            editor: editor
        }), !noAtomics && /*#__PURE__*/ React.createElement(Reaction, {
            editor: editor
        }), !noAtomics && /*#__PURE__*/ React.createElement(AddMedia, {
            editor: editor
        }), !noAtomics && /*#__PURE__*/ React.createElement(Gif, {
            editor: editor
        }), !noAtomics && /*#__PURE__*/ React.createElement(Muro, {
            standalone: true,
            editor: editor
        }), !noAtomics && /*#__PURE__*/ React.createElement(Separator, {
            editor: editor
        }), /*#__PURE__*/ React.createElement(Link, {
            editor: editor
        }), !noAtomics && /*#__PURE__*/ React.createElement(Separator, {
            editor: editor
        }), /*#__PURE__*/ React.createElement(Bold, {
            editor: editor
        }), /*#__PURE__*/ React.createElement(Italic, {
            editor: editor
        }), /*#__PURE__*/ React.createElement(TextDecoration, {
            editor: editor
        }), /*#__PURE__*/ React.createElement(FontFamily, {
            editor: editor
        }), /*#__PURE__*/ React.createElement(FontColor, {
            editor: editor
        }), /*#__PURE__*/ React.createElement(FontHighlight, {
            editor: editor
        }), /*#__PURE__*/ React.createElement(BlockFormatting, {
            editor: editor
        }), /*#__PURE__*/ React.createElement(Alignment, {
            editor: editor
        }), /*#__PURE__*/ React.createElement(Indent, {
            editor: editor
        }), /*#__PURE__*/ React.createElement(Outdent, {
            editor: editor
        }), /*#__PURE__*/ React.createElement(Blockquote, {
            editor: editor
        }), /*#__PURE__*/ React.createElement(List, {
            editor: editor
        }), !omitHRule && /*#__PURE__*/ React.createElement(HRule, {
            editor: editor
        }));
    }
    return /*#__PURE__*/ React.createElement(ThemeOverride, {
        themeSurface: ThemeSurface.TERTIARY,
        className: cn(s['root'], wrapping && s['wrapping'], className)
    }, !wrapping && /*#__PURE__*/ React.createElement(Slider, {
        permArrows: true,
        forceMobileArrows: true,
        renderNextButton: (props)=>/*#__PURE__*/ React.createElement(SliderNext, _object_spread({
                editor: editor
            }, props)),
        renderPrevButton: (props)=>/*#__PURE__*/ React.createElement(SliderPrev, _object_spread({
                editor: editor
            }, props)),
        contentClassName: "menu-scrollable"
    }, buttons), wrapping && buttons);
};
EverythingMenu.displayName = 'EverythingMenu';
export default EverythingMenu;

//# sourceMappingURL=EverythingMenu.js.map